import "./index.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../assets/images/icon-clock.svg";
import { selectAuthField } from "../../redux/selectors";
import { formatDuration } from "../../utils/utils";
import { updateContestStatus } from "../../redux/contests/actions";

export default function ClockTime() {
  const dispatch = useDispatch();
  const startTime = useSelector(selectAuthField('timer'));
  const [elapsedTime, setElapsedTime] = useState(formatDuration(startTime, Date.now()));

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsedTime(formatDuration(startTime, Date.now()));
      dispatch(updateContestStatus());
    }, 1000);
    return () => window.clearInterval(interval);
  }, [startTime]);

  return (
    <div className="wrapper-icon-clock">
      <img src={Icon} alt="wrapper-icon-clock" /> {elapsedTime}
    </div>
  );
}
